import { Scope } from '../graphql/generated/graphql';

export interface Filter {
  [key: string]: string | string[] | number | number[];
}

export interface Measure {
  measureName: string;
  label?: string;
  filters?: Filter;
  global?: boolean;
}

// This is a templerory solution, soon we have a more generic solution based on the usecases.
export enum ActionName {
  addGrant = 'addGrant',
  removeGrant = 'removeGrant',
}

export interface Action {
  actionName: ActionName;
  labels: string[];
  undoable?: boolean;
  ids?: string[];
}
export interface MeasureRequest {
  measureName: string;
  filters?: Filter;
  global?: boolean;
  sortable?: boolean;
  label?: string;
  ascending?: boolean;
  link?: boolean;
  linkTemplate?: string;
  showExternalLink?: boolean;
  actions?: Action[];
  description?: string;
  dataOnly?: boolean;
}

export interface Entity {
  name?: string;
  entity: string;
  alternativeEntities?: string[];
  selection: string;
  sortBy?: MeasureRequest;
  limit?: number;
  filters?: Filter;
  colorIndex?: number;
  entityIds?: string[];
  label?: string;
}

interface ReliabilityMetrics {
  [key: string]: number;
}

export interface Facet {
  entity: string;
  labels?: Record<string, string>;
}
// Todo: can be removed once the old contract for facets are completely deprecated
export type FacetUnion = Facet | string;

export interface Visualisation {
  type: string;
  showPageSizeControl?: boolean;
  defaultPageSize?: number;
  simplified?: boolean;
  measures: MeasureRequest[];
  facets?: FacetUnion[];
  download?: boolean;
  chartColors?: string[];
  showRowNumber?: boolean;
  showIcon?: boolean;
  showTitle?: boolean;
  showZeroCounts?: boolean;
}

export interface FragmentConfig {
  id?: string | number;
  description: string;
  group?: string;
  visualisations: Visualisation[];
  additionalVisualisations?: [string];
  emptyStateMessage?: string;
  title?: string;
  subTitle?: MeasureRequest[];
  entities: Entity[];
  reliabilityMetrics?: ReliabilityMetrics;
  scope?: Scope;
  filters?: Filter;
  fragmentName?: string;
  template?: string;
  dataFormat?: string;
}

export type EventTrigger = (name: string, detail?: any) => void;
